import React from 'react';
import {UrlFixer} from "../../utils/utils";
import {useNavigate} from "react-router-dom";
import {ListItemContainer, ListItemText, ListItemThumb} from "../../utils/common-styles";
import {DateDisplay} from "../Extra/DateDisplay";
import {NewsListPostMeta, NewsListStyledIntro} from "../../utils/common-styles";

export const NewsListItem = ({post}) => {

    const navigate = useNavigate();

    const clickHandler = (newsItemId, slug) => {
        let targetUrl = `/news/${newsItemId}/${slug}`;
        navigate(targetUrl);
    }

    return (
        <ListItemContainer onClick={(e) => clickHandler(post.id, post.slug)}>
            <ListItemThumb>
                <img src={UrlFixer(post.image_details.variations.detail_hero)} alt={post.caption} />
            </ListItemThumb>
            <ListItemText>
                <h2><a href={"/news/"+post.id+"/"+post.slug}>{post.title}</a></h2>
                <NewsListPostMeta>
                    <ul>
                        <li><i className="fas fa-calendar-alt"> </i> <DateDisplay datetime={post.published_at}/></li>
                        {post.tags && post.tags.length > 0 && (
                            <li>
                                <i className="fas fa-tags"></i>
                                {post.tags.map((tag) => (
                                    <span key={tag.id}> {tag.name}</span>
                                ))}
                            </li>
                        )}
                    </ul>
                </NewsListPostMeta>
                <NewsListStyledIntro>{post.intro}</NewsListStyledIntro>
            </ListItemText>
        </ListItemContainer>
    )
}